import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';
import { TecnicaTerapeutica } from '../models/';

@Injectable()
export class TecnicasTerapeuticasService extends RESTService<any> {

  public tecnicaTerapeutica: TecnicaTerapeutica;

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/resumenPaciente',
    });
  }

  /**
   * getTecnicasTerapeuticas: obtiene el listado completo de tecnicasTerapeuticas de un paciente
   * @param pacienteId: string
   * @return any
   */
  obtenerTecnicasTerapeuticas(pacienteId: string, visita: string): any {
    // Parametros fijos
    let params: any = {
      iNumVisita: visita,
      iIdModulo: '1',
      iNumExpediente: pacienteId,
    };
    return this._http.post(environment.api_host + 'tecnicasTerapeuticas/obtenerTecnicasTerapeuticas', params).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  /**
   * guardarTecnicaTerapeutica
   * @param any Object
   * @return boolean
   */
  guardarTecnicaTerapeutica(params: any): Observable<boolean> {
    return this._http.post(environment.api_host + 'tecnicasTerapeuticas/guardarTecnicaTerapeutica', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.resultado === 'OK') {
        return true;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }

  /**
   * eliminarTecnicasTerapeuticas
   * @param pacienteId: string
   * @param tecnicaTerapeuticaId: string
   * @return JSON Object
   */
  eliminarTecnicaTerapeutica(pacienteId: string, tecnicaTerapeuticaId: string): any {
    let res: any = {
      resultado: {
        estado: 'Ok',
        mensaje: 'Técnica Terapéutica borrada correctamente',
      },
    };
    return JSON.stringify(res);
  }
}



// WEBPACK FOOTER //
// ./src/services/tecnicasterapeuticas.service.ts